import { useEffect, useRef } from "react";

const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

// Modal/panel accessibility: focus moves in on open, Tab is trapped, Escape closes, focus returns to the trigger on close.
export default function useDialogA11y(open, onClose) {
  const ref = useRef(null);
  const trigger = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    trigger.current = document.activeElement;
    const el = ref.current;
    const first = el?.querySelector(FOCUSABLE);
    (first || el)?.focus?.();
    const onKey = (e) => {
      if (e.key === "Escape") { e.stopPropagation(); onClose?.(); return; }
      if (e.key !== "Tab" || !el) return;
      const items = [...el.querySelectorAll(FOCUSABLE)].filter((x) => x.offsetParent !== null);
      if (!items.length) return;
      const [a, z] = [items[0], items[items.length - 1]];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    };
    document.addEventListener("keydown", onKey);
    return () => { document.removeEventListener("keydown", onKey); trigger.current?.focus?.(); };
  }, [open, onClose]);
  return ref;
}
